import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import store from './store'
import './permission'
import 'element-ui/lib/theme-chalk/base.css'
import 'element-ui/lib/theme-chalk/index.css'
import './icons'
import * as filters from './filters'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import i18n from './locales/vueIN'
import { 
  Button, 
  Menu, 
  Layout, 
  ConfigProvider,
  Dropdown,
  Avatar,
  Tabs,
  Radio,
  Tag,
  Spin,
  Rate,
  Checkbox,
  Input,
  List,
  Form,
  Row,
  Col,
  Space,
  Card,
  Pagination
} from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.component(CollapseTransition.name, CollapseTransition)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(Button)
Vue.use(Menu)
Vue.use(Layout)
Vue.use(ConfigProvider)
Vue.use(Dropdown)
Vue.use(Avatar)
Vue.use(Tabs)
Vue.use(Radio)
Vue.use(Tag)
Vue.use(Spin)
Vue.use(Rate)
Vue.use(Checkbox)
Vue.use(Input)
Vue.use(List)
Vue.use(Form)
Vue.use(Row)
Vue.use(Col)
Vue.use(Space)
Vue.use(Card)
Vue.use(Pagination)
let vue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})

Vue.use(vue)



// WEBPACK FOOTER //
// ./src/main.js